import type { CSSProperties } from "react";
import type { DrawingProps } from "./types";

interface TickProps extends DrawingProps {
  /** Draw the stroke on when motion is allowed. */
  animate?: boolean;
  delay?: number;
}

/** The marigold tick. It draws itself once, and only where a thing is right. */
export function Tick({ size = 40, className, title, animate = false, delay = 0 }: TickProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <circle cx="20" cy="20" r="17" fill="var(--marigold)" stroke="var(--ink)" strokeWidth="2.5" />
      <path
        d="m12 20.5 5.4 5.8L28.5 14"
        stroke="var(--ink)"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={animate ? "draw" : undefined}
        style={animate ? ({ "--len": 30, "--delay": `${delay}ms` } as CSSProperties) : undefined}
      />
    </svg>
  );
}
